<template>
  <Transition name="fade">
    <div
      v-if="exportStore.isExporting"
      class="fixed top-0 left-0 right-0 z-50 bg-white shadow-md"
    >
      <div class="container mx-auto px-4 py-2">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#385660]"></div>
            <span class="text-[#385660]">{{ exportStore.exportMessage }}</span>
          </div>
          <div class="w-32 h-2 bg-gray-200 rounded-full overflow-hidden">
            <div
              class="h-full bg-[#385660] transition-all duration-300"
              :style="{ width: `${exportStore.exportProgress}%` }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useExportStore } from '@/stores/exportStore'

const exportStore = useExportStore()
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
</style> 